import { useMutation } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { ConsentsFilter } from "../query-keys";

type CommonUpsertConsentType = {
  hasConsented: boolean;
};

type UpsertConsent = CommonUpsertConsentType & {
  organiserId?: string | null;
  structureId?: string | null;
};

type UpsertProfesionnalConsent = {
  id: string;
  hasConsented: boolean;
};

type UpsertConsentMultipleProfesionnals = {
  organisers?: UpsertProfesionnalConsent[];
  structures?: UpsertProfesionnalConsent[];
};

const upsertConsent = async (content: UpsertConsent) => {
  const { data } = await privateAxios.post(`/consents/upsert`, content);
  return data;
};

export const useUpsertConsent = () => {
  return useMutation({
    mutationFn: (content: UpsertConsent) => upsertConsent(content),
  });
};

const upsertConsentMultipleProfesionnals = async (
  content: UpsertConsentMultipleProfesionnals
) => {
  const { data } = await privateAxios.post(
    `/consents/upsert-multiple-profesionnals`,
    content
  );
  return data;
};

export const useUpsertConsentMultipleProfesionnals = () => {
  return useMutation({
    mutationFn: (content: UpsertConsentMultipleProfesionnals) =>
      upsertConsentMultipleProfesionnals(content),
  });
};

const exportConsents = async (filters?: ConsentsFilter) => {
  const { data } = await privateAxios.get<Blob>(`/consents/export`, {
    params: filters,
    responseType: "blob",
  });
  return data;
};

export const useExportConsents = () => {
  return useMutation({
    mutationFn: (filters?: ConsentsFilter) => exportConsents(filters),
  });
};
